import axios from 'axios'
import { withAuth } from 'utils/authHeaders'

/**
 * Performs postal code CBSA lookup and derives assetType from locationType.
 * Consolidates logic previously duplicated across 6+ location edit callbacks.
 */
export const prepareLocationForSave = async (values: any): Promise<any> => {
	const newLocation = { ...values }

	if (newLocation.postalCode) {
		const postalCode = newLocation.postalCode.substring(0, 5)
		try {
			await axios.get(
				'/api/postalcodedemographics/postalcodecbsa',
				withAuth({ params: { postalCode } }),
			)
		} catch (e) {
			console.error(e)
		}
	}

	const locationType = newLocation.locationType
	switch (locationType) {
		case 'Commercial Center':
		case 'Retail Center':
			newLocation.assetType = 'center'
			break
		default:
			newLocation.assetType = 'location'
			break
	}

	newLocation.updateNote = 'Edited Location.'
	return newLocation
}
